import * as React from "react";
import {uniqueId} from "lodash";
import {useState} from "react";

const RadioButton = ({label, checked, value, name, onChange}) => {
  const [id] = useState(uniqueId('radio-'))
  return (
    <div className={"flex items-center gap-1"}>
      <input type="radio"
             id={id}
             name={name}
             value={value}
             checked={checked}
             className={"appearance-none h-5 w-5 border border-primary rounded-full bg-white checked:bg-primary checked:shadow-white checked:shadow-inner-sharp cursor-pointer"}
             onChange={onChange}/>
      <label htmlFor={id} className="cursor-pointer">
        {label}
      </label>
    </div>
  )
}

export default RadioButton
